import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { forwardRef, useState } from 'react';
import css from './AuthField.module.scss';

interface AuthFieldProps extends React.ComponentProps<typeof TextField> {
  showPassword?: boolean;
  onTogglePassword?: () => void;
}

export const AuthField = forwardRef<HTMLInputElement, AuthFieldProps>((props, ref) => {
  const { showPassword, onTogglePassword, ...rest } = props;
  const [localShowPassword, setLocalShowPassword] = useState(false);
  const isPassword = props.type === 'password';

  const handleClickShowPassword = () => {
    if (onTogglePassword) {
      onTogglePassword();
    } else {
      setLocalShowPassword(!localShowPassword);
    }
  };

  const shouldShowPassword = showPassword !== undefined ? showPassword : localShowPassword;

  return (
    <TextField
      {...rest}
      ref={ref}
      fullWidth
      margin="normal"
      variant="outlined"
      type={isPassword && !shouldShowPassword ? 'password' : 'text'}
      slotProps={{
        input: {
          ...props.slotProps?.input,
          endAdornment: isPassword ? (
            <InputAdornment position="end" sx={{ marginRight: '8px' }}>
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                edge="end"
              >
                {shouldShowPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ) : null,
        },
        inputLabel: {
          shrink: true,
        },
      }}
      className={css.authField}
    />
  );
});
